require('./edit-review.scss')

module.exports = {
  template: require('./edit-review.pug')()
  controller: require('./edit-review.ctrl')
  bindings:
    review: '<'
}
